import { MapOwnerFilter, MapsFilter } from 'features/maps/types'
import MapsFilterOwnerSelector from './MapsFilterOwnerSelector'
import TagFilterSelector from 'features/tags/ui/TagFilterSelector'
import { FeatureFlag, useFeatureFlag } from 'app/ui/useFeatureFlag'

interface MapsFilterSelector {
  filter?: MapsFilter
  onFilterChange: (type: 'permissions' | 'tags', filter: MapOwnerFilter | string[]) => void
}

function MapsFilterSelector({ filter, onFilterChange }: MapsFilterSelector) {
  const hasTagsForResourcesEnabled = useFeatureFlag(FeatureFlag.TagsForResources)

  return (
    <>
      {hasTagsForResourcesEnabled && (
        <TagFilterSelector onFilterChange={(filter) => onFilterChange('tags', filter)} value={filter?.tags} />
      )}
      <MapsFilterOwnerSelector
        onFilterChange={(filter) => onFilterChange('permissions', filter)}
        value={filter?.permissions}
      />
    </>
  )
}

export default MapsFilterSelector
